import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { ProductSummaryData } from '../../../../../../models/order/workflow/product-summary.model';


@Injectable({ providedIn: 'root' })
export class ProductSummaryStateService extends BaseWorkflowStateService<ProductSummaryData> {
    override stateKey: string = 'productSummary';
}